import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

const ReferralProgramNav = props => {
  useEffect(() => {
    // eslint-disable-next-line no-undef
    $(`#panelGroupMenu_c_6`).collapse(props.isOpen ? 'show' : 'hide');
  }, [props.isOpen]);

  return (
    <div className="panel panel-default">
      <div className="panel-heading" role="tab" id="panelGroupMenu_h_6">
        <a
          className="dropdown-toggle dropdown-toggle-collapse collapsed"
          role="button"
          aria-expanded="false"
          href={null}
          aria-controls="panelGroupMenu_c_6"
          title={t('Партнерская программа')}
          onClick={props.onToggle}
        >
          <i className="fa fa-handshake-o fa-lg fa-fw" aria-hidden="true" />{' '}
          {t('Партнерская программа')}
        </a>
      </div>
      <div
        id="panelGroupMenu_c_6"
        className={'panel-collapse collapse'}
        role="tabpanel"
        aria-labelledby="panelGroupMenu_h_6"
      >
        <div className="list-group">
          <NavLink
            to="/referral-program/my-stat"
            activeClassName="active"
            className="list-group-item"
          >
            <span className="list-group-item-val">{t('Статистика')}</span>
          </NavLink>
          <NavLink
            to="/referral-program/promotional-materials"
            activeClassName="active"
            className="list-group-item"
          >
            <span className="list-group-item-val">
              {t('Рекламные материалы')}
            </span>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

ReferralProgramNav.defaultProps = {
  isOpen: false,
  onToggle: () => {}
};

ReferralProgramNav.propTypes = {
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func
};

export default ReferralProgramNav;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Sidebar/Navs/ReferralProgramNav.js